'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _Toolkit = require('./Toolkit.css');

var _Toolkit2 = _interopRequireDefault(_Toolkit);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _reactCopyToClipboard = require('react-copy-to-clipboard');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toolkit = (_dec = (0, _reactCssModules2.default)(_Toolkit2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Toolkit, _Component);

  function Toolkit(props) {
    (0, _classCallCheck3.default)(this, Toolkit);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Toolkit.__proto__ || (0, _getPrototypeOf2.default)(Toolkit)).call(this, props));

    _this.onCopy = function () {
      _this.setState({ copied: true });
    };

    _this.renderVideoWrap = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'content-photo-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'contents' },
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'Sustainable, Fossil Free 401(k)s'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'How sustainable and fossil-free are your 401k fund choices? Your 401(k) portfolio could be an engine for more positive impact. Join Fossil Free Funds and HIP Investor for a webinar to learn how to advance your employer-sponsored retirement plan to reflect more sustainable fund choices that are better positioned for a future world of cleaner, greener energy \u2013 while seeking lower future risk in your portfolio.'
            )
          ),
          _react2.default.createElement(
            _components.Link,
            {
              to: '../files/webinar-slides/Sustainable-Fossil-Free-401ks-FossilFreeFunds-AsYouSow-HIPinvestor.pdf',
              title: 'Sustainable, Fossil Free 401(k)s - Webinar slide deck',
              targetBlank: true
            },
            _react2.default.createElement(
              'div',
              { styleName: 'slide-btn tlink' },
              _react2.default.createElement('i', { className: 'fa fa-file-o' }),
              '\xA0\xA0\xA0View the slides',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'photo-wrap' },
          _react2.default.createElement(_reactPlayer2.default, {
            url: 'https://vimeo.com/151846057',
            volume: 0.5 })
        )
      );
    };

    _this.renderToolkit401kGraphicWrap = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'content-photo-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'contents' },
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'If your investments are in your employer-sponsored plan'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'It is possible to change what the plan offers, but it will take more effort than if you have an IRA or a personal investment that you solely control (see below). You will need to engage the plan administrator to help find the right blend of funds to satisfy the many employees that all invest in the same basket of mutual funds. This may take time and possibly some coordination with your co-plan participants.'
            )
          )
        ),
        _react2.default.createElement('div', {
          styleName: 'photo-graphic',
          title: 'Americans have $5.1 trillion invested in 401(k)s'
        })
      );
    };

    _this.renderToolkitFundsPhotoWrap = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'content-photo-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'contents' },
          _react2.default.createElement(
            'div',
            { styleName: 'answer-title' },
            'If you\u2019re an individual investor'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-info' },
            _react2.default.createElement(
              'p',
              null,
              'It\u2019s your money, and your financial advisor works for you. You just need to have a meeting to discuss what you have learned about your holdings and how you would like them changed to align with your values. An investment professional will advise you of potential risk and you can make your own decisions.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'You can trade your own portfolio, or tell your manager to do it. They may push back and tell you that you\u2019ll make less money. Again, you can reply, \u201CMaybe, but it\u2019s my money, I want less risk, and fossil fuels are a risky business.\u201D It\u2019s a financial advisors job to manage ',
              _react2.default.createElement(
                'i',
                null,
                'your'
              ),
              ' money, so you should drive home the point in no uncertain terms.'
            )
          )
        ),
        _react2.default.createElement('div', {
          styleName: 'photo-funds',
          title: 'How to make a change and invest your money fossil free'
        })
      );
    };

    _this.renderToolkitContent = function (toolkitTitle) {
      var url = _config2.default.domain + _config2.default.routes.toolkit;
      var message = 'Action toolkit to move your money';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'toolkit' },
          _react2.default.createElement(
            'div',
            { styleName: 'toolkit-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'title' },
              'Fossil free action toolkit'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'subtitle' },
              'How to make a change and invest your money fossil free'
            ),
            _this.renderToolkitFundsPhotoWrap(),
            _react2.default.createElement(
              'p',
              null,
              'Ask for help finding the best choices. The advisor may say no if you tell them to invest in a specific fund because it has a short or rocky history, so you may need to be patient as they find a better alternative. The goal is to remove the risk, not a specific fund; focus on risk, especially future risk, as well as returns. If they\u2019re being lazy or unwilling to help you with this transition, find a new advisor. If your broker is tied to a big-name brand, they may only be able to offer products that the particular company has approved. If you want innovation, you might need a new advisor.'
            ),
            _react2.default.createElement(_components.SocialButtons, { message: message, link: url }),
            _react2.default.createElement(
              'div',
              { styleName: 'section-title' },
              'Resources for investing fossil free'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We\'ve collected a set of resources that can help you get started on your fossil free investing journey. From financial consulting firms, to educational resources, to research providers, these resources explain the details of socially responsible financial investing, and help to ensure you\'re working with firms that are aligning your investments with your values.'
            ),
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.resources,
                title: 'Resources'
              },
              _react2.default.createElement(
                'div',
                { styleName: 'tlink slide-btn' },
                'Resources',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          )
        ),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(
          'div',
          { styleName: 'toolkit' },
          _react2.default.createElement(
            'div',
            { styleName: 'toolkit-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'section-title' },
              'Adding fossil free options to your retirement plan'
            ),
            _this.renderToolkit401kGraphicWrap(),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Step 1 \u2013 Talk to your colleagues and build a coalition'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'content-info' },
              _react2.default.createElement(
                'p',
                null,
                'To effectively advocate for new offerings through your employer-sponsored plan, first build a coalition of peers and interested co-workers inside your company. Your voice will be much stronger as a group. If you\u2019re writing to someone in power, advocating on behalf of 10 or even 20 people carries a lot more weight than just one. One way to spur interest would be sharing the results from your Fossil Free Funds search among fellow employees. All plan participants are offered the same basket of mutual funds as you are, so they are probably asking the same questions right now.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Some companies have \u201Cgreen teams,\u201D and there may be affinity groups for women or LGBT employees, and if there isn\u2019t one already, it may be time to create one for climate change. Communicate with your co-workers through a company intranet, employee portal, a company newsletter, corporate chats, or social media. '
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title-spaceabove' },
              'Step 2 \u2013 Identify the best people to speak with'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'content-info' },
              _react2.default.createElement(
                'p',
                null,
                'The 401(k)/403(b) plan administrator, manager, or coordinator should be known if you are a plan participant, and that\u2019s where to start. There could also be a chief sustainability officer or employee engagement manager, and those could be good resources. An effective method is to go to the LinkedIn pages of those people and find who might have some sympathy for the cause. Do any of them volunteer or have connections with organizations concerned with climate change? Look for indicators that they\u2019re friendly to sustainability and start contacting them in order of their friendliness. In a publicly listed company with more structure, a coalition is vital to signal to managers that it\u2019s an important issue for many employees. If it\u2019s a smaller company, the CFO or CEO could be approached directly. In a mid-size or family company, a family member could be more influential.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title-spaceabove' },
              'Step 3 \u2013 Bring a solution to the table'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'content-info' },
              _react2.default.createElement(
                'p',
                null,
                'The usual starting point in these conversations is: \u201CWe want to reduce the future risk of our 401(k) fund choices. We also want to invest in a clean energy future. How can we enhance our 401(k) choices to do so?\u201D Here are the criteria. Getting new fund choices added to the list of the existing plan options is a formal process, and could take up to a year to be added. Larger companies often have some form of investment committee, which engages an investment advisor. There may be some funds in your plan that you see contain only one fossil fuel company. You could ask the plan administrator to call the fund manager and say, \u201CIs there a substitute for this one company? If you made one change you would be fossil free free!\u201D'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If the investment advisor and plan administrator refuse to help in swapping out some fossil fuel-heavy funds for some fossil free funds, you may need to get fellow employees to sign a petition requesting the change and send it to the investment committee. If you are told, \u201CBut you\u2019ll make less money if you\u2019re not invested in fossil fuels,\u201D you can say, \u201CActually, fossil fuels are a risky investment. We want to diversify, and be part of the clean energy future.\u201D'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title-spaceabove' },
              'Sample letter to plan administrator'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'content-info' },
              _react2.default.createElement(
                'div',
                { styleName: 'letter-boxquote' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Dear Plan Administrator,'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'I am an employee of ',
                  _react2.default.createElement(
                    'strong',
                    null,
                    '[Company Name]'
                  ),
                  ', and I participate in our company 401(k) plan, which represents the bulk of my retirement savings. I am writing to inquire about fossil free and socially responsible investment options in the plan.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'I am concerned about the financial risks associated with investing my retirement savings in fossil fuel companies. Laws curbing the use of fossil fuels are being put in place, energy efficiency measures are being implemented across nearly every sector of the economy, and renewable energy is driving down demand for fossil fuel-based energy. These changes pose substantial financial risk to fossil fuel companies. One example of this growing risk: over the past five years, the largest U.S coal companies have gone bankrupt, while other U.S. based coal firms have lost nearly 90% of their stock value.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    'I believe it is my right to know what companies my retirement savings are invested in.'
                  ),
                  ' Can you please tell me how I can find out what fossil fuel companies are held in each of the investment options offered in our company plan? Does our retirement plan offer any fossil free, socially responsible options?'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Socially responsible investing is no longer just an ethical issue. It is a key factor impacting financial well-being. New guidelines from the Department of Labor state that \u201Cenvironmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment\u201D and can be used when making decisions related to fiduciary duty.  '
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'There is an online tool, fossilfreefunds.org, which screens many commonly available mutual funds for investments in fossil fuel companies, and identifies funds that are socially responsible and fossil free. ',
                  _react2.default.createElement(
                    'strong',
                    null,
                    'If none of our current plan options are socially responsible and fossil free, this tool could be used to find suitable mutual funds that could be included in our plan.'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Best,'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    '[Your Name]'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    '[Your contact information (company department, email, phone)]'
                  )
                )
              ),
              _react2.default.createElement(
                _reactCopyToClipboard.CopyToClipboard,
                {
                  onCopy: _this.onCopy,
                  text: _this.state.value },
                _react2.default.createElement(
                  'button',
                  {
                    styleName: 'letter-boxquote-copy-button' },
                  _this.state.copied ? null : _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement('i', { className: 'fa fa-files-o' }),
                    '\xA0\xA0\xA0'
                  ),
                  _this.state.copied ? 'Copied!' : 'Copy to clipboard'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'section-title' },
              'Watch our video how-to guide'
            ),
            _this.renderVideoWrap()
          )
        ),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(
          'div',
          { styleName: 'toolkit' },
          _react2.default.createElement(
            'div',
            { styleName: 'toolkit-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'section-title' },
              'White paper'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Aligning defined contribution plans with corporate sustainability goals to spur employee innovation and engagement'
            ),
            _react2.default.createElement(
              'p',
              null,
              'As millennial-aged employees now represent the majority of the U.S. workforce, it is increasingly important that corporate management finds ways to engage them in the company. Creating defined contribution plans which connect to their core values \u2013 like solving human, social and environmental problems through their work and investments \u2013 can spur employee engagement and spark innovation.'
            ),
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.links.whitePaper,
                title: 'Read the white paper' },
              _react2.default.createElement(
                'div',
                { styleName: 'slide-btn tlink' },
                'Read the white paper',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Furthermore, adding ESG funds to an organization\u2019s employee contribution plan enables a corporation to align its stated climate, environmental, social, and other sustainability policies, including adoption of U.N. Sustainable Development Goals (SDGs), and the U.N. Principles of Responsible Investing (UNPRI) with its investment options. The oft-heard phrase, \u201Cput your money where your mouth is\u201D has never been truer or easier to implement.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Between 2012 and 2016 the market for mutual funds and exchange traded funds (ETFs) with an Environmental, Social, or Governance (ESG) focus has increased $4.98 trillion, up to $8.72 trillion, a growth of over 133%.[i]  The benefits of including ESG considerations in investment decisions have become more widely understood and the market has responded by increasing investments in funds that include these concerns in their prospectus and holdings. In addition to the potential financial upside of ESG investments, a growing number of investors are moving to ESG-oriented funds as a way to reduce risk and incorporate their values in their investment decisions. This is largely driven by the increasing proportion of millennials in the workforce. A whopping 85% of millennials surveyed in the 2016 U.S. Trust study, \u201CInsights on Wealth and Worth,\u201D said they consider their investment decisions as \u201Ca way to express their social, political, and environmental values.\u201D[ii]'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Despite the growth of ESG-oriented funds in the wider investment market, the $8.4 trillion in U.S. corporate defined contribution plans (including 401(k), 403(b), and IRAs) do not reflect this growth and in fact have barely begun to include ESG funds in their portfolios.[iii] As an example, Vanguard reported that only 9% of its employee plans included ESG funds, most of which offered only a single fund rather than a suite of offerings.[iv] This discrepancy provides a tremendous opportunity for corporate plan administrators to align corporate values and sustainability goals with investments, while simultaneously enticing new employees, retaining existing ones, and increasing participation and contributions through a simple change in policy.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'A recent 2015 Department of Labor ERISA guidance document indicates that considering ESG issues when making investments is not only allowed as part of a fiduciaries\u2019 consideration, but where such issues may directly affect the economic value of an investment, fiduciaries should appropriately consider such factors.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This white paper highlights case studies and recent investing trends demonstrating the benefits of incorporating ESG options into corporate defined contribution plans. It shows that those corporations providing a greater array of ESG mutual funds and exchange traded funds (ETFs) in their plans will benefit from overall corporate coherence of policy and practice and facilitate a shift in corporate culture to respect and amplify employee values. This leads to material benefits for both the company and the employees, is relatively simple to implement once an executive decision is made to make such an adjustment, and is most successful when employees are part of the process from the beginning and through implementation.'
            ),
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.links.whitePaper,
                title: 'Read the white paper' },
              _react2.default.createElement(
                'div',
                { styleName: 'slide-btn tlink' },
                'Read the white paper',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title-spaceabove' },
              'Acknowledgements'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Thanks to R. Paul Herman, founder and CEO of HIP Investor which rates 401(k) plans for fossil free and sustainability, for his assistance in writing this toolkit and to Rob Thomas of Social(k) and Timothy Yee of Green Retirement for reviewing it.'
            ),
            _react2.default.createElement('br', null)
          )
        )
      );
    };

    _this.state = {
      value: 'Dear Plan Administrator,\nI am an employee of [Company Name], and I participate in our company 401(k) plan, which represents the bulk of my retirement savings. I am writing to inquire about fossil free and socially responsible investment options in the plan.\nI am concerned about the financial risks associated with investing my retirement savings in fossil fuel companies. Laws curbing the use of fossil fuels are being put in place, energy efficiency measures are being implemented across nearly every sector of the economy, and renewable energy is driving down demand for fossil fuel-based energy. These changes pose substantial financial risk to fossil fuel companies. One example of this growing risk: over the past five years, the largest U.S coal companies have gone bankrupt, while other U.S. based coal firms have lost nearly 90% of their stock value.\nI believe it is my right to know what companies my retirement savings are invested in. Can you please tell me how I can find out what fossil fuel companies are held in each of the investment options offered in our company plan? Does our retirement plan offer any fossil free, socially responsible options?\nSocially responsible investing is no longer just an ethical issue. It is a key factor impacting financial well-being. New guidelines from the Department of Labor state that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be used when making decisions related to fiduciary duty.\nThere is an online tool, FossilFreeFunds.org, which screens many commonly available mutual funds for investments in fossil fuel companies, and identifies funds that are socially responsible and fossil free. If none of our current plan options are socially responsible and fossil free, this tool could be used to find suitable mutual funds that could be included in our plan.\nThank you in advance for looking into this. I appreciate your time and look forward to hearing from you.\nBest,\n[Your Name]\n[Your contact information (company department, email, phone)]',
      copied: false
    };
    return _this;
  }

  (0, _createClass3.default)(Toolkit, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'Fossil free action toolkit';
      var description = 'Get your money out of fossil fuels. Use the Fossil Free Funds Action Toolkit to make a change and move your money.';
      var url = _config2.default.domain + _config2.default.routes.toolkit;

      // const bannerImage = 'green'
      // const bannerHeadline = 'Fossil free action toolkit'
      // const bannerSubtitle = 'Action toolkit to move your money'

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        this.renderToolkitContent(title),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(
          'div',
          { styleName: 'toolkit' },
          _react2.default.createElement(
            'div',
            { styleName: 'toolkit-inner' },
            _react2.default.createElement(_components.AboutBanner, null)
          )
        )
      );
    }
  }]);
  return Toolkit;
}(_react.Component)) || _class);
exports.default = Toolkit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Toolkit/Toolkit.js
// module id = 1421
// module chunks = 0